import React from "react";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";
import { get, map, includes, filter } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import images from "../../../assets/img/images";

const MultipleInfoSection = (props) => {
  const { title, title2, values, typeId, language } = props;

  return (
    <Grid item style={{ padding: "8px" }}>
      <Box className={"text-87 bold-500"}>
        {title2 ? title2 : I18n.get("profiles_" + title)}
      </Box>
      {title === "ocrValues" && (
        <Box
          className="text-54 text-italic"
          style={{ marginBottom: "14px", fontSize: "1em" }}
        >
          {values && values.length > 0 && values[0].value
            ? I18n.get("site_ocrValuesMsg")
            : I18n.get("site_noOCR")}
        </Box>
      )}
      {map(values, (item, index) => (
        <Grid
          container
          key={`${get(item, ["id"])}_${index}`}
          wrap="nowrap"
          style={{
            //marginBottom: values.length > 0 ? "8px" : "0px",
            overflowWrap: "break-word",
          }}
        >
          {(title === "ocrValues" || includes(title2, "OCR")) &&
            !props.noCheckmark && (
              <Grid
                item
                className="text-54"
                style={{
                  marginTop: "-4px",
                  lineHeight: "22px",
                  minWidth: "30px",
                  textAlign: "center",
                  fontSize: "1.7em",
                  paddingRight: "5px",
                }}
              >
                {item.mandatory_match && (
                  <img src={images.checkmarkGrey} alt="checkmark" />
                )}
              </Grid>
            )}
          <Grid item style={{ overflow: "auto" }}>
            <span className="text-54">{item.value || "-"}</span>
            <span className="text-54" style={{ paddingLeft: "4px" }}>
              {get(item, ["attributes"]) &&
                ` (${get(
                  filter(
                    get(item, ["attributes"]),
                    (attr) => attr.id === typeId
                  ),
                  [0, "picklist", `name_${language}`]
                )})`}
            </span>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

MultipleInfoSection.propTypes = {
  title: PropTypes.string,
  values: PropTypes.array,
};

export default MultipleInfoSection;
